import React from 'react';
import propTypes from 'prop-types';

const NativeSelect = ({
  options,
  onChange,
  id,
  label,
  name,
  placeholder,
  value,
  isDisabled = false,
}) => (
  <div className="cmp-form__control-wrapper">
    <label
      htmlFor={id}
      className={`cmp-form__control-label ${isDisabled ? 'cmp-form__control-label--disabled' : ''}`}
      data-testid="native-select-label"
    >
      {label}
    </label>
    <select
      id={id}
      name={name}
      className="cmp-form__select"
      onChange={onChange}
      value={value}
      disabled={isDisabled}
    >
      <option value="" disabled hidden>{placeholder}</option>
      {options.map((opt) => (
        <option key={opt.value} value={opt.value}>
          {opt.label}
        </option>
      ))}
    </select>
  </div>
);

NativeSelect.propTypes = {
  options: propTypes.arrayOf(propTypes.shape({
    value: propTypes.oneOfType([
      propTypes.string,
      propTypes.number,
    ]),
    label: propTypes.oneOfType([
      propTypes.string,
      propTypes.number,
    ]),
  })),
  onChange: propTypes.func,
  id: propTypes.string,
  label: propTypes.string,
  name: propTypes.string,
  placeholder: propTypes.string,
  value: propTypes.oneOfType([
    propTypes.string,
    propTypes.number,
  ]),
  isDisabled: propTypes.bool,
};

export default NativeSelect;
